import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (nw.length < 6) { toast.error("Password baru minimal 6 karakter"); return; }
    if (nw !== nw2) { toast.error("Konfirmasi password tidak cocok"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password berhasil diperbarui");
      setCur(""); setNw(""); setNw2(""); onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle className="font-heading text-2xl text-burgundy">Ganti Password</DialogTitle></DialogHeader>
        <div className="space-y-3 py-2">
          <div><Label className="text-xs font-semibold mb-1 block">Password Saat Ini</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="cp-current" /></div>
          <div><Label className="text-xs font-semibold mb-1 block">Password Baru</Label><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="cp-new" /></div>
          <div><Label className="text-xs font-semibold mb-1 block">Konfirmasi Password Baru</Label><Input type="password" value={nw2} onChange={(e) => setNw2(e.target.value)} data-testid="cp-new2" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Batal</Button>
          <Button onClick={submit} disabled={saving} data-testid="cp-submit" className="bg-burgundy hover:bg-burgundy-dark text-white">Simpan</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
